import { styled } from "@mui/material/styles";
import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import React, { ReactElement, ReactNode } from "react";

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    padding: "8px",
    borderRadius: "8px",
    color: "#333",
    maxWidth: "400px",
    fontSize: theme.typography.pxToRem(12),
    marginTop: "-8px",
    boxShadow: "rgba(99, 99, 99, 0.4) 0px 2px 8px 0px",
  },
}));

interface Props extends TooltipProps {
  children: ReactElement<any, any> & ReactNode;
  title: ReactElement<any, any> & ReactNode;
}

const CustomTooltip: React.FC<Props> = ({ title, children, ...rest }) => {
  return (
    <HtmlTooltip title={title} {...rest}>
      {children}
    </HtmlTooltip>
  );
};

export default CustomTooltip;
